import script from "./EditRecipient.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRecipient.vue?vue&type=script&setup=true&lang=js"

import "./EditRecipient.vue?vue&type=style&index=0&id=09251f3d&lang=css"

const __exports__ = script;

export default __exports__